import { render } from "./EnglandWalesScreen.vue?vue&type=template&id=b08bcc14&scoped=true"
import script from "./EnglandWalesScreen.vue?vue&type=script&lang=js"
export * from "./EnglandWalesScreen.vue?vue&type=script&lang=js"

import "./EnglandWalesScreen.vue?vue&type=style&index=0&id=b08bcc14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08bcc14"]])

export default __exports__